import { render, staticRenderFns } from "./GoToTop.vue?vue&type=template&id=64ddeb88&scoped=true&"
import script from "./GoToTop.vue?vue&type=script&lang=js&"
export * from "./GoToTop.vue?vue&type=script&lang=js&"
import style0 from "./GoToTop.vue?vue&type=style&index=0&id=64ddeb88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ddeb88",
  null
  
)

export default component.exports